mutation addAirdropBonus($eth_address: String, $bonus_type: String , $description: String, $claim_option: Boolean, $airdrop_bonus: Float) {
    addAirdropBonus(eth_address: $eth_address, bonus_type: $bonus_type, description: $description, claim_option: $claim_option, airdrop_bonus: $airdrop_bonus) 
}
